import { RequestStatus } from '@/constants/API';
import { IPageDataResponse } from '@/types/common';
import type { PayloadAction } from '@reduxjs/toolkit';
import { createSlice } from '@reduxjs/toolkit';

import { SnapshotDetail } from './type';

export interface SnapshotState {
  getSnapshotListStatus: RequestStatus;
  revertSnapshotStatus: RequestStatus;
  snapshots: IPageDataResponse<SnapshotDetail> | null;
}

const initialState: SnapshotState = {
  getSnapshotListStatus: RequestStatus.IDLE,
  revertSnapshotStatus: RequestStatus.IDLE,
  snapshots: null,
};

export const snapshotSlice: any = createSlice({
  name: 'snapshot',
  initialState,
  reducers: {
    getSnapshotListRequest: (state, action: PayloadAction<any>) => {
      state.getSnapshotListStatus = RequestStatus.REQUESTING;
    },
    getSnapshotListSuccess: (state, action: PayloadAction<any>) => {
      state.getSnapshotListStatus = RequestStatus.SUCCESS;
      state.snapshots = action.payload;
    },
    getSnapshotListFailure: (state, action: PayloadAction<any>) => {
      state.getSnapshotListStatus = RequestStatus.ERROR;
    },
    revertSnapshotRequest: (state, action: PayloadAction<any>) => {
      if (action) state.revertSnapshotStatus = RequestStatus.REQUESTING;
    },
    revertSnapshotSuccess: (state, action: PayloadAction<any>) => {
      state.revertSnapshotStatus = RequestStatus.SUCCESS;
    },
    revertSnapshotFailure: (state, action: PayloadAction<any>) => {
      state.revertSnapshotStatus = RequestStatus.ERROR;
    },
    resetSnapshotRequestStatus: state => {
      state.getSnapshotListStatus = RequestStatus.IDLE;
      state.revertSnapshotStatus = RequestStatus.IDLE;
    },
  },
});

export const {
  getSnapshotListRequest,
  getSnapshotListSuccess,
  getSnapshotListFailure,
  revertSnapshotRequest,
  revertSnapshotSuccess,
  revertSnapshotFailure,
  resetSnapshotRequestStatus,
} = snapshotSlice.actions;

export default snapshotSlice.reducer;
